import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage', {
    title: '{templateName} Workflow | {companyName}',
    breadcrumbsSectionName: 'Approval workflows',
    unnamed: 'Unnamed',
});
